// components/PinHalo.jsx — the pulsing rings on the selected pin.
// ---------------------------------------------------------------------------
// 2026-09-15 — Brett: "bit hard to see the selected pin. Can you make it
// pulsate". The old pulse animated a box-shadow on the pin's transparent 16×24
// button: a faint rectangle, run twice, then gone. Two rings now grow out of the
// pin head and fade, for as long as the pin is selected.
//
// Rendered INSIDE the pin button, so it follows the pin and its counter-zoom.
// pointer-events none, so a tap — and the pin-under-the-tap lookup — still finds
// the pin itself. Someone who has asked their device for less motion gets a
// steady ring instead.
// ---------------------------------------------------------------------------

import React from 'react';
import { theme } from '../theme';

// Head centre in the 16×24 pin: the pin SVG's viewBox is 40×60 with the head
// at (22, 18), so (8.8, 7.2).
const HEAD_X = 8.8;
const HEAD_Y = 7.2;
const SIZE = 18;

export const PIN_HALO_CSS = `
  @keyframes fdpPinHalo {
    0%   { transform: scale(0.5); opacity: 0.95; }
    100% { transform: scale(3); opacity: 0; }
  }
  @media (prefers-reduced-motion: reduce) {
    [data-pin-halo] { animation: none !important; transform: scale(1.7); opacity: 0.85; }
  }
`;

export default function PinHalo() {
  // The second ring starts half a cycle in (a negative delay), so there are
  // always two rings on the way out and no static ring before it starts.
  const ring = (delay) => (
    <span
      key={delay}
      data-pin-halo
      aria-hidden
      style={{
        position: 'absolute', left: HEAD_X - SIZE / 2, top: HEAD_Y - SIZE / 2,
        width: SIZE, height: SIZE, boxSizing: 'border-box', borderRadius: '50%',
        border: `2.5px solid ${theme.brand}`, pointerEvents: 'none',
        animation: `fdpPinHalo 1.6s ease-out ${delay}s infinite`,
      }}
    />
  );
  return <>{ring(0)}{ring(-0.8)}</>;
}
